<template>
  <div class="s-text-left">
    <span>
      <s-label :label="label" class="s-font-medium" />
      <span v-if="showMandatory" class="s-text-danger-600">*</span>
    </span>
    <div class="telephone">
      <div style="width: 100px">
        <s-select
          autofocus
          :value="getCountryByCode(countryCode)"
          :disabled="disableCountryCode"
          :searchable="true"
          :clearable="false"
          width-menu="full"
          :options="getCountries()"
          @update="
            (selectedCountryCode) =>
              setCountryCode(
                getCountryCodeByCountryAbbreviation(selectedCountryCode)
              )
          "
          :class="'c-flex-grow-1 phone-select s-w-10'"
        >
          <template #option="options">
            <div class="dial-code-option">
              <div class="s-w-9 s-text-right s-text-neutral-400">
                {{ options.option.countryCode }}
              </div>
              <div>{{ options.option.displayText.split(",")[0] }}</div>
            </div>
          </template>
          <template #value="internalPlaceholder">
            <div class="selected-code">
              {{
                getCountryCode(internalPlaceholder.value.displayText)
              }}
            </div>
          </template>
        </s-select>
      </div>
      <s-input
        :value="value"
        :max-length="14"
        :id="id"
        @input="setPhoneNumber"
        @keyup.enter="onEnter"
        class="c-flex-grow-1 phone-input"
      />
    </div>
    <c-inline-error v-if="Boolean(error)" :message="error" />
  </div>
</template>
<script>
import {CountryCodeListSortedByName} from '@/data/country-code-list';
import {formatPhoneNumber} from '@/app/utils/common/functions/functions';
import {EventBus} from '@/events/event-bus';
import {FormEvents} from '@/app/utils/common/constants';

export default {
  name: 'PhoneInput',
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: [String, Function],
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: false,
      default: undefined,
    },
    setValue: {
      type: Function,
      required: true,
    },
    countryCode: {
      type: String,
      required: true,
    },
    showMandatory: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableCountryCode: Boolean,
  },
  data: function () {
    return {
      phone: this.value,
      phoneCountryCode: this.countryCode,
    };
  },
  methods: {
    getCountries: () =>
      CountryCodeListSortedByName.map((x) => ({
        displayText: x.displayText + "," + x.dialCode,
        countryCode: x.dialCode,
        value: x.twoLetterCode,
      })),
    getCountryCode: function (name) {
      if (name === undefined) return '';
      return this.getCountries().find((x) => x.displayText === name)
        ?.countryCode;
    },
    getTwoLetterCountryCode: function (name) {
      if (name === undefined) return '';
      return this.getCountries().find((x) => x.displayText === name)?.value;
    },
    getCountryCodeByCountryAbbreviation: function (country) {
      if (country === undefined) return '';
      return this.getCountries().find((x) => x.value === country)?.countryCode;
    },
    getCountryByCode: function (code) {
      if (code === undefined) return '';
      return this.getCountries().find((x) => x.countryCode === code)?.value;
    },
    setCountryCode: function (countryCode) {
      this.phoneCountryCode = countryCode;
      this.setValue(countryCode, formatPhoneNumber(this.phone));
    },
    setPhoneNumber: function (event) {
      this.phone = event.target.value;
      this.setValue(
        this.phoneCountryCode,
        formatPhoneNumber(event.target.value)
      );
    },
    onEnter() {
      EventBus.$emit(FormEvents.ENTER);
    },
  },
};
</script>
<style lang="scss">
.telephone {
  display: flex;
  flex-direction: row;
  align-items: start;

  border-radius: 6px;
  border: 1px solid #bcbcd4;

  &:focus-within {
    outline: 2px solid rgb(59 130 246 / 1);
  }

  & .dial-code-option {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .s-selectmenu-trigger {
    border: none;
    outline: none;
  }

  .s-selectmenu-trigger:focus {
    border: none;
    outline: none;
  }

  .s-selectmenu-trigger:active {
    border: none;
    outline: none;
  }

  .s-selectmenu-content {
    min-width: auto;
  }

  .s-selectmenu-item {
    width: 300px;
  }

  .s-inputfield {
    border: none;
  }

  input {
    --tw-ring-shadow: 0 0 #000 !important;
  }

  .s-inputfield:focus {
    outline: none;
  }
}
</style>
